import { createAction, props } from "@ngrx/store";
import { GlobalDateSettingsInterface } from "#models/AssignReview/global-date-settings.interface";
import { AutoProgressAssignablesInterface } from "#models/AssignReview/auto-progress-assignables.interface";
import { MaxAttemptsAssignablesInterface } from "#models/AssignReview/max-attempts-assignables.interface";

// Global Dates
export const setGlobalDateSettings = createAction(
    "[Assign] Set Global Date Settings",
    props<{
        payload: GlobalDateSettingsInterface | null;
    }>()
);

// Global Auto Progress
export const setGlobalAutoProgress = createAction(
    "[Assign] Set Global Auto Progress",
    props<{
        payload: boolean;
    }>()
);

// Auto Progress Assignables
export const setAutoProgressAssignables = createAction(
    "[Assign] Set Auto Progress Assignables",
    props<{
        payload: AutoProgressAssignablesInterface[];
    }>()
);
export const clearAutoProgressAssignables = createAction(
    "[Assign] Clear Auto Progress Assignables"
);

// Max Attempts
export const setGlobalMaxAttempts = createAction(
    "[Assign] Set Global Max Attempts",
    props<{
        payload: number | null;
    }>()
);

// Global Language Options
export const setGlobalLanguageOptions = createAction(
    "[Assign] Set Global Language Options",
    props<{
        payload: number;
    }>()
);

// Max Attempts Assignables
export const setMaxAttemptsAssignables = createAction(
    "[Assign] Set Max Attempts Assignables",
    props<{
        payload: MaxAttemptsAssignablesInterface[];
    }>()
);
